import React from 'react';
import styled, {keyframes} from 'styled-components';
import {Draggable} from './Draggable';

const ViewportSliderBar: React.FC<
    React.PropsWithChildren<{previewSize: number; setPreviewSize: (newSize: number) => void}>
> = ({previewSize, setPreviewSize}) => {
    return (
        <SliderWrapper>
            <ViewportSliderBarRoot>
                <SliderContainer>
                    <MobileSectionContainer>
                        <MobileSection />
                    </MobileSectionContainer>
                    <TabletSectionContainer>
                        <TabletSection />
                    </TabletSectionContainer>
                    <DesktopSectionContainer>
                        <DesktopSection />
                    </DesktopSectionContainer>
                </SliderContainer>
                <SliderContainerOverlay>
                    <LeftArrow></LeftArrow>
                    <RightArrow></RightArrow>
                </SliderContainerOverlay>
                <DraggableContainer
                    onClick={(e) => {
                        e.stopPropagation();
                    }}
                >
                    <Draggable previewSize={previewSize} setPreviewSize={setPreviewSize}></Draggable>
                </DraggableContainer>
            </ViewportSliderBarRoot>
        </SliderWrapper>
    );
};

const wiggleAnimation = keyframes`
    10%, 90% {
        transform: translateX(-1px);
    }

    20%, 80% {
        transform: translateX(1px);
    }

    30%, 50%, 70% {
        transform: translateX(-2px);
    }

    40%, 60% {
        transform: translateX(2px);
    }
`;

const ViewportSliderBarRoot = styled.div`
    width: 500px;
`;

const MobileSectionContainer = styled.div`
    flex-grow: 300;
    align-items: center;
    justify-content: center;
    margin: auto auto auto 45px;
    text-align: center;
`;

const TabletSectionContainer = styled.div`
    flex-grow: 300;
    align-items: center;
    justify-content: center;
    margin: auto;
    text-align: center;
`;

const DesktopSectionContainer = styled.div`
    flex-grow: 1000;
    align-items: center;
    justify-content: center;
    margin: auto;
    text-align: center;
`;

const SliderContainer = styled.div`
    width: 500px;
    border-radius: 3px;
    margin: 10px auto -2px auto;
    position: relative;
    display: flex;
    justify-content: space-evenly;
    color: black;
    font-size: 14px;
    font-family: Inter;
`;

const SliderContainerOverlay = styled.div`
    width: 545px;
    margin: -4px auto -2px auto;
    position: absolute;
    display: flex;
    justify-content: space-evenly;
`;

const MobileSection = styled.div`
    height: 4px;
    background-color: blue;
    border-radius: 3px 0px 0px 3px;
`;

const TabletSection = styled.div`
    height: 4px;
    background-color: purple;
`;

const DesktopSection = styled.div`
    height: 4px;
    background-color: orange;
    border-radius: 0px 3px 3px 0px;
`;

const DraggableContainer = styled.div`
    margin: auto auto 45px auto;
    animation: ${wiggleAnimation} 3s;
`;

const SliderWrapper = styled.div`
    margin-left: -45px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 550px;
    font-size: 14px;
    font-family: Inter;
`;

const LeftArrow = styled.i`
    border: solid #0e0c0e;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(135deg);
    margin-right: 390px;
`;

const RightArrow = styled.i`
    border: solid #0e0c0e;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 3px;
    transform: rotate(-45deg);
`;

export default ViewportSliderBar;
